import moment from 'moment';

const initialState = {
  oaName: '',
  publicType: [],
  activityType: [],
  startDate: null,
  endDate: null,
  activityDate: [],
  oaPublicType: [],
  oaActivityType: [],
  oaStartDate: null,
  oaEndDate: null,
  oaActivityDate: [],
  activeTab: 'sobre',
  options: [],
  activitiesOptions: [],
  cities: [],
};

const filters = (state = initialState, action) => {
  switch (action.type) {
    case 'OA_NAME':
      return {
        ...state,
        oaName: action.payload,
      };
    case 'OA_PUBLIC':
      return {
        ...state,
        oaPublicType: action.payload,

      };
    case 'OA_PUBLIC_ACT':
      return {
        ...state,
        publicType: action.payload,

      };
    case 'ACTIVITY_TYPE':
      return {
        ...state,
        oaActivityType: action.payload,

      };
    case 'ACTIVITY_TYPE_ACT':
      return {
        ...state,
        activityType: action.payload,

      };
    case 'SET_DATES_ACT':
      const { startDate, endDate } = action.payload;
      const activityDate = [];
      if (startDate) {
        activityDate.push({ label: moment(startDate).format('DD/MM/YYYY'), value: moment(startDate).format('DD/MM/YYYY') });
      }
      if (endDate) {
        activityDate.push({ label: moment(endDate).format('DD/MM/YYYY'), value: moment(endDate).format('DD/MM/YYYY') });
      }
      return {
        ...state,
        startDate: startDate ? moment(startDate) : null,
        endDate: endDate ? moment(endDate) : null,
        activityDate,
      };
    case 'SET_DATES':
      const { startDate: oaStartDate, endDate: oaEndDate } = action.payload;
      const oaActivityDate = [];
      if (oaStartDate) {
        oaActivityDate.push({ label: moment(oaStartDate).format('DD/MM/YYYY'), value: moment(oaStartDate).format('DD/MM/YYYY') });
      }
      if (oaEndDate) {
        oaActivityDate.push({ label: moment(oaEndDate).format('DD/MM/YYYY'), value: moment(oaEndDate).format('DD/MM/YYYY') });
      }
      return {
        ...state,
        oaStartDate: oaStartDate ? moment(oaStartDate) : null,
        oaEndDate: oaEndDate ? moment(oaEndDate) : null,
        oaActivityDate,
      };
    case 'SET_ACTIVE_TAB':
      return {
        ...state,
        activeTab: action.payload,
      };
    case 'SET_FILTER_OPTIONS':
      return {
        ...state,
        options: action.payload,
      };
    case 'SET_ACTIVITIES_OPTIONS':
      return {
        ...state,
        activitiesOptions: action.payload,
      };
    case 'SET_CITIES':
      return {
        ...state,
        cities: action.payload,
      };
    default:
      return state;
  }
};

export default filters;
